/***
*
*   SETUP WELCOME SCREEN
*   You can delete this when you've completed the setup process.
*
**********/

import { Fragment } from 'react';

export function SetupWelcome() {

  return (
    <Fragment>

      <p>Welcome to Mission Control.</p>
      <p>These next few steps will help you set up your internal SaaS dashboard.</p>
      <p>If you need help, <a href='https://docs.usegravity.app'>please refer to the docs</a> or <a href='mailto:support@usegravity.app'>contact support.</a></p>

    </Fragment>
  )
}